/***
 * Author：zyk
 * Date：2022-07-08 11:54:32
 * Description: 前端自动检查是否有升级通知
 * Copyright © 2020 找我婚礼. All rights reserved.
 **/

import { getNotice } from "../api/http";
import { createNotification } from "../utils";

// 定时器
let noticeTimer = null;
// 上次访问时间 ms
let lastSeenMS = 0;
// 一秒 ms
const OneSecondMS = 1000;

let projectKey = "";

/**
 * 检查更新
 * @returns
 */
export const injectNotice = async (key) => {
  projectKey = key;
  // 初次进入需要立即执行一次并且开启轮询
  // 立即查询一次
  driver.immediate();
  // 开始轮询
  driver.startInterval(OneSecondMS * 60 * 30);

  // 监听visibilitychange事件
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") {
      // 离开时记录当前时间
      lastSeenMS = Date.now();
      // 停止轮询
      driver.stopInterval();
    } else {
      // 回到当前页面时 记录当前时间
      const currentMS = Date.now();

      // 防止10秒之内频繁切换
      if (currentMS - lastSeenMS > OneSecondMS * 10) {
        // 立即查询一次
        driver.immediate();
        // 开始轮询
        driver.startInterval(OneSecondMS * 60 * 60);
      }
    }
  });
};

/**
 * 各种操作的驱动器
 */
let driver = {
  immediate: () => {
    getNewMessage();
  },
  startInterval: (ms) => {
    noticeTimer = window.setInterval(() => {
      getNewMessage();
    }, ms);
  },
  stopInterval: () => {
    window.clearInterval(noticeTimer);
  },
};

/**
 * 查询新的未读消息
 * @returns
 */
const getNewMessage = async () => {
  const { data } = await getNotice(projectKey);
  if (!data || !data.length) return;

  const { remark } = data[0];
  createNotification("升级公告", remark);
};
